import {CommonMethods} from '@PosterWhiteboard/common-methods';
import type {ItemConfig} from '@PosterWhiteboard/items/item/item.types';
import {AnimationType} from '@PosterWhiteboard/items/item/item.types';
import type {RGBA} from '@Utils/color.util';
import {AnimationSpeed} from '@PosterWhiteboard/classes/item-animation.class';

const DEFAULT_TRANSITION_COLOR: RGBA = [255, 255, 255, 1];

export interface TransitionObject extends ItemConfig {
  type?: AnimationType;
  color?: RGBA;
  speed?: AnimationSpeed;
}

export class Transition extends CommonMethods {
  public type = AnimationType.FADE;
  public speed = AnimationSpeed.MEDIUM;
  public color: RGBA = DEFAULT_TRANSITION_COLOR;

  public toObject(): TransitionObject {
    return {
      type: this.type,
      speed: this.speed,
      color: this.color,
    };
  }

  public updateFromObject(object: Record<string, any>): void {
    this.copyVals(object);
  }
}
